import { makeStyles } from 'tss-react/mui'



export const useStyles = makeStyles()((theme) => {
    return {
        slTargetLabel: {
            fontSize: '12px'
        },
        disabled: {
            opacity: 0.6
        },
        disabledInputClickBackdrop: {
            position: "absolute",
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            cursor: 'pointer'
        }
    }
})